import CustomButton from '@/common/CustomButton';
import styles from './styles.module.less';
import {
  ArrowLeftOutlined,
  CaretLeftOutlined,
  CaretRightOutlined,
  CheckCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  LeftOutlined,
  PlusCircleFilled,
  RightOutlined,
  SendOutlined
} from '@ant-design/icons';
import {
  Button,
  DatePicker,
  Popconfirm,
  Select,
  Space,
  Tag,
  Tooltip,
  Typography
} from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AddWeeklyTask from './AddWeeklyTask';
import WeeklyDatePickerModal from './ForwardTask';
import CustomTable from '@/common/Table';
import { columnRenderer, headerRenderer } from 'utilities/helpers';
import dayjs from 'dayjs';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteWeeklyPlanAsync,
  fetchWeeklyPlans,
  selectWeeklyPlansSlice,
  updateExecutiveMemberAsync,
  updateWeeklyPlanStatusAsync
} from '../redux/slice';
import { getAllProjects, getAllUsers } from 'pages/Tasks/redux/slice';

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;

const WeeklyList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDateModalOpen, setIsDateModalOpen] = useState(false);

  const [selectedRange, setSelectedRange] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedWeekMonday, setSelectedWeekMonday] = useState(null);
  const [editTask, setEditTask] = useState(null);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [isMemberModalOpen, setIsMemberModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedMemberRecord, setSelectedMemberRecord] = useState(null);
  const [executiveMembers, setExecutiveMembers] = useState([]);
  const statusPopupRef = useRef(null);
  const memberPopupRef = useRef(null);

  const RECORDS_PER_PAGE = 10;

  const [tablePagination, setTablePagination] = useState({
    current: 1,
    pageSize: RECORDS_PER_PAGE,
    total: 0
  });

  const { loading, weeklyPlans, pagination, pendingPlans, pendingLoading } =
    useSelector(selectWeeklyPlansSlice);

  useEffect(() => {
    dispatch(
      fetchWeeklyPlans({
        status: 'ACTIVE'
      })
    );
  }, [dispatch]);

  console.log('pendingPlans', pendingPlans);

  useEffect(() => {
    dispatch(getAllProjects()).then((res) => {
      if (res?.payload?.success) {
        setProjects(res.payload.data || []);
      }
    });
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllUsers()).then((res) => {
      if (res?.payload?.success) {
        const members = (res.payload.data || []).filter(
          (user) => user.role_id === 3
        );
        setExecutiveMembers(members);
      }
    });
  }, [dispatch]);

  console.log('executiveMembers', executiveMembers);

  const projectMap = React.useMemo(() => {
    const map = {};
    projects.forEach((p) => {
      map[p.id] = p.project;
    });
    return map;
  }, [projects]);

  const clientMap = React.useMemo(() => {
    const map = {};
    projects.forEach((p) => {
      map[p.client.id] = p.client.client_name;
    });
    return map;
  }, [projects]);

  const fetchCurrentWeekPlans = (page = tablePagination.current) => {
    if (!selectedWeekMonday) return;
    dispatch(
      fetchWeeklyPlans({
        start_date: selectedWeekMonday.format('YYYY-MM-DD'),
        end_date: selectedWeekMonday
          .clone()
          .add(4, 'days')
          .format('YYYY-MM-DD'),
        page,
        per_page: tablePagination.pageSize
      })
    ).then((res) => {
      if (res?.payload?.success) {
        setTablePagination((prev) => ({
          ...prev,
          total: res.payload.pagination.total_records
        }));
      }
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isStatusModalOpen &&
        statusPopupRef.current &&
        !statusPopupRef.current.contains(event.target)
      ) {
        setIsStatusModalOpen(false);
        setSelectedRecord(null);
      }
      if (
        isMemberModalOpen &&
        memberPopupRef.current &&
        !memberPopupRef.current.contains(event.target)
      ) {
        setIsMemberModalOpen(false);
        setSelectedMemberRecord(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isStatusModalOpen, isMemberModalOpen]);

  const isFutureWeek =
    selectedWeekMonday &&
    selectedWeekMonday.isAfter(moment().startOf('isoWeek'), 'week');

  const columns = [
    {
      title: headerRenderer('S.No.'),
      dataIndex: 'index',
      key: 'index',
      width: '5%',
      // render: (text) => columnRenderer(text, '!text-gray-500')
      render: (text) => (
        <div style={{ fontSize: 12 }} className="text-gray-500">
          {/* {columnRenderer(text, '!text-gray-500')} */}
          {text}
        </div>
      )
    },
    {
      title: headerRenderer('Task Name'),
      dataIndex: 'task_name',
      key: 'task_name',
      width: '25%',
      // render: (text) => columnRenderer(text, '!text-gray-700')
      render: (text) => (
        <div style={{ fontSize: 12 }} className="text-gray-500">
          {text}
        </div>
      )
    },
    {
      title: headerRenderer('Type'),
      dataIndex: 'type',
      key: 'type',
      width: '15%',
      // render: (text) => columnRenderer(text, '!text-gray-500')
      render: (text) => (
        <div style={{ fontSize: 12 }} className="text-gray-500">
          {text}
        </div>
      )
    },
    {
      title: headerRenderer('Company'),
      dataIndex: 'company',
      key: 'company',
      width: '15%',
      // render: (text) => columnRenderer(text, '!text-gray-500')
      render: (text) => (
        <div style={{ fontSize: 12 }} className="text-gray-500">
          {text}
        </div>
      )
    },
    {
      title: headerRenderer('Project'),
      dataIndex: 'project',
      key: 'project',
      width: '15%',
      // render: (text) => columnRenderer(text, '!text-gray-500')
      render: (text) => (
        <div style={{ fontSize: 12 }} className="text-gray-500">
          {text}
        </div>
      )
    },
    {
      title: headerRenderer('Executive'),
      dataIndex: 'member',
      key: 'member',
      width: '15%',
      render: (text, record) => {
        const isCompleted = record.status === 'Completed';
        return (
          <div className={styles.statusCell}>
            <span
              className={
                isCompleted ? styles.statusDisabled : styles.statusClickablee
              }
              style={{ fontSize: 12 }}
              onClick={() => {
                if (isCompleted) return;
                setSelectedMemberRecord(record);
                setIsMemberModalOpen(true);
              }}
            >
              {text}
            </span>
            {!isCompleted &&
              isMemberModalOpen &&
              selectedMemberRecord?.key === record.key && (
                <div className={styles.memberPopup} ref={memberPopupRef}>
                  {executiveMembers
                    .filter(
                      (member) =>
                        Number(member.id) !== Number(record.executive_id)
                    )
                    .map((member) => (
                      <div
                        key={member.id}
                        className={styles.memberPopupItem}
                        onClick={() => {
                          dispatch(
                            updateExecutiveMemberAsync({
                              id: selectedMemberRecord.key,
                              executive_id: member.id
                            })
                          ).then((res) => {
                            if (res?.meta?.requestStatus === 'fulfilled') {
                              setIsMemberModalOpen(false);
                              setSelectedMemberRecord(null);
                              fetchCurrentWeekPlans();
                            }
                          });
                        }}
                      >
                        {member.first_name} {member.last_name}
                      </div>
                    ))}
                </div>
              )}
          </div>
        );
      }
    },
    {
      title: headerRenderer('Status'),
      dataIndex: 'status',
      key: 'status',
      width: '13%',
      render: (text, record) => {
        const isCompleted = text === 'Completed';
        const disableStatus = isCompleted;
        return (
          // <Select
          //   value={text}
          //   style={{ width: '100%' }}
          //   size="small"
          //   disabled={isCompleted} // ✅ disable when completed
          //   onChange={(value) => {
          //     dispatch(
          //       updateWeeklyPlanStatusAsync({
          //         id: record.key,
          //         status: value === 'Active' ? 'ACTIVE' : 'COMPLETED'
          //       })
          //     );
          //   }}
          //   options={[
          //     { label: 'Active', value: 'Active' },
          //     { label: 'Completed', value: 'Completed' }
          //   ]}
          // />
          <div className={styles.statusCell}>
            <span
              className={
                disableStatus ? styles.statusDisabled : styles.statusClickable
              }
              onClick={() => {
                if (disableStatus) return;

                setSelectedRecord({
                  key: record.key,
                  status: text
                });
                setIsStatusModalOpen(true);
              }}
            >
              {text}
            </span>

            {isStatusModalOpen && selectedRecord?.key === record.key && (
              <div className={styles.statusPopup} ref={statusPopupRef}>
                <div
                  className={styles.completeAction}
                  onClick={() => {
                    dispatch(
                      updateWeeklyPlanStatusAsync({
                        id: selectedRecord.key,
                        status: 'COMPLETED'
                      })
                    ).then((res) => {
                      if (res?.meta?.requestStatus === 'fulfilled') {
                        setIsStatusModalOpen(false);
                        setSelectedRecord(null);
                        fetchCurrentWeekPlans();
                      }
                    });
                  }}
                >
                  <CheckCircleOutlined style={{ color: 'green' }} /> Complete
                </div>

                {/* <div className={styles.popupActions}>
                  <Button
                    size="small"
                    onClick={() => {
                      setIsStatusModalOpen(false);
                      setSelectedRecord(null);
                    }}
                  >
                    Cancel
                  </Button>
                </div> */}
              </div>
            )}
          </div>
        );
      }
    },
    {
      title: headerRenderer('Actions'),
      key: 'actions',
      width: '15%',
      render: (_, record) => {
        const isCompleted = record.status === 'Completed';

        return (
          <div
            className={`flex items-center gap-6 ${
              isCompleted
                ? 'text-gray-400 cursor-not-allowed'
                : 'text-[#0653fa] cursor-pointer'
            }`}
          >
            <Tooltip title={isCompleted ? 'Task is completed' : 'Edit'}>
              <EditOutlined
                onClick={() => {
                  if (isCompleted) return; // ❌ block click
                  setEditTask(
                    weeklyPlans.find((item) => item.id === record.key)
                  );
                  setIsModalOpen(true);
                }}
              />
            </Tooltip>

            <Tooltip title={isCompleted ? 'Task is completed' : 'Postpone'}>
              <SendOutlined
                onClick={() => {
                  if (isCompleted) return;
                  setSelectedPlanId(record.key);
                  setIsDateModalOpen(true);
                }}
              />
            </Tooltip>

            {isCompleted ? (
              <DeleteOutlined
                style={{ cursor: 'not-allowed', color: '#9CA3AF' }}
              />
            ) : (
              <Popconfirm
                title={
                  <>
                    <div>Please Confirm</div>
                    <div
                      style={{
                        color: 'rgba(0, 0, 0, 0.45)'
                      }}
                    >
                      Are you sure you want to delete this task?
                    </div>
                  </>
                }
                placement="left"
                onConfirm={() =>
                  dispatch(deleteWeeklyPlanAsync({ id: record.key })).then(
                    (res) => {
                      if (res?.payload?.success) {
                        fetchCurrentWeekPlans();
                      }
                    }
                  )
                }
                okText="Delete"
                cancelText="No"
              >
                <DeleteOutlined
                  style={{
                    color: 'red',
                    cursor: 'pointer'
                  }}
                />
              </Popconfirm>
            )}
          </div>
        );
      }
    }
  ];

  const tableData = React.useMemo(() => {
    return (weeklyPlans || []).map((item, index) => {
      const executive = executiveMembers.find(
        (m) => Number(m.id) === Number(item.executive_id)
      );
      const memberName = executive
        ? `${executive.first_name} ${executive.last_name}`
        : '—';
      return {
        key: item.id,
        index: index + 1,
        task_name: item.task_name,
        type: item.type,
        company: clientMap[item.client_id] || '—',
        member: memberName,
        executive_id: item.executive_id,
        project: projectMap[item.project_id] || '—',
        status: item.status === 'ACTIVE' ? 'Active' : 'Completed'
      };
    });
  }, [weeklyPlans, clientMap, projectMap, executiveMembers]);

  useEffect(() => {
    const monday = moment().startOf('isoWeek');
    setSelectedWeekMonday(monday);
  }, []);

  const getWeekRange = (date) => {
    const monday = moment(date).startOf('isoWeek');
    const friday = moment(monday).add(4, 'days');
    return [monday, friday];
  };

  useEffect(() => {
    const range = getWeekRange(moment());
    setSelectedRange(range);
  }, []);

  const handlePrevWeek = () => {
    setSelectedWeekMonday((prev) => prev.clone().subtract(1, 'week'));
  };

  const handleNextWeek = () => {
    // if (isCurrentWeek) return;
    setSelectedWeekMonday((prev) => prev.clone().add(1, 'week'));
  };

  // const weekText = getWeekRangeText(selectedDate);

  const weekRange = React.useMemo(() => {
    if (!selectedWeekMonday) return [];
    const friday = selectedWeekMonday.clone().add(4, 'days');
    return [selectedWeekMonday, friday];
  }, [selectedWeekMonday]);

  const weekText = React.useMemo(() => {
    if (!selectedWeekMonday) return '';
    const friday = selectedWeekMonday.clone().add(4, 'days');
    return `${selectedWeekMonday.format('DD MMM')} - ${friday.format(
      'DD MMM'
    )}`;
  }, [selectedWeekMonday]);

  useEffect(() => {
    if (!selectedWeekMonday) return;

    dispatch(
      fetchWeeklyPlans({
        start_date: selectedWeekMonday.format('YYYY-MM-DD'),
        end_date: selectedWeekMonday
          .clone()
          .add(4, 'days')
          .format('YYYY-MM-DD'),
        page: tablePagination.current,
        per_page: tablePagination.pageSize
      })
    ).then((res) => {
      if (res?.payload?.success) {
        setTablePagination((prev) => ({
          ...prev,
          total: res.payload.pagination.total_records
        }));
      }
    });
  }, [
    dispatch,
    selectedWeekMonday,
    tablePagination.current,
    tablePagination.pageSize
  ]);

  useEffect(() => {
    setTablePagination((prev) => ({
      ...prev,
      current: 1
    }));
  }, [selectedWeekMonday]);

  const handleTableChange = (newPagination) => {
    setTablePagination((prev) => ({
      ...prev,
      current: newPagination.current,
      pageSize: newPagination.pageSize
    }));
  };

  return (
    <section className={'mb-12 overflow-hidden md:overflow-y-auto'}>
      <Title level={5} className={'!text-xl !m-0 lg:!text-3xl !font-bold'}>
        Top priorities
      </Title>

      <div className="flex flex-col items-start justify-between gap-2 md:flex-row pb-[20px]">
        <div className="flex items-center gap-4">
          <div className="text-[#000000d9] mb-[5px] text-base mt-[10px]">
            <Space size={12}>
              <LeftOutlined
                className="cursor-pointer"
                onClick={handlePrevWeek}
              />

              {weekText}

              <RightOutlined
                className={`cursor-pointer`}
                onClick={handleNextWeek}
              />
            </Space>
          </div>
        </div>
        <div className="flex justify-end md:justify-center">
          {/* <RangePicker
            value={weekRange}
            disabledDate={disabledDate}
            allowClear={false}
            format="YYYY-MM-DD"
            inputReadOnly
            onCalendarChange={(dates) => {
              if (!dates || !dates[0]) return;

              const monday = moment(dates[0]).startOf('isoWeek');
              setSelectedWeekMonday(monday);
            }}
            onChange={() => {}}
          /> */}

          <DatePicker
            picker="week"
            style={{ width: 150 }}
            allowClear={false}
            value={selectedWeekMonday}
            disabledDate={(current) => {
              if (!current) return false;

              const day = current.day(); // 0 = Sunday, 6 = Saturday
              return day === 0 || day === 6;
            }}
            onChange={(date) => {
              if (!date) return;
              setSelectedWeekMonday(moment(date).startOf('isoWeek'));
            }}
            format={(value) => {
              const monday = value.clone().startOf('isoWeek');
              const friday = monday.clone().add(4, 'days');
              return `${monday.format('DD MMM')} - ${friday.format('DD MMM')}`;
            }}
          />

          <CustomButton
            type="primary"
            className="lg:ml-[10px] lg:mr-[10px]"
            onClick={() => setIsModalOpen(true)}
          >
            <PlusCircleFilled /> Add Task
          </CustomButton>
          <CustomButton type="outlined" onClick={() => navigate('/dashboard')}>
            <ArrowLeftOutlined /> Back to Dashboard
          </CustomButton>
        </div>
      </div>
      <div className={styles.weeklyTableOverride}>
        <CustomTable
          columns={columns}
          dataSource={tableData}
          loading={loading}
          onChange={handleTableChange}
          pagination={{
            current: tablePagination.current,
            pageSize: tablePagination.pageSize,
            total: tablePagination.total
          }}
          emptyText="No weekly tasks"
        />
      </div>

      <div className="flex flex-col items-start justify-between gap-2 md:flex-row pb-[20px] pt-[30px]">
        <div className="flex items-center gap-4">
          <Title level={5} className={'!text-xl !m-0 lg:!text-xl !font-bold'}>
            Pending tasks
          </Title>
        </div>
      </div>

      <div className="flex flex-col gap-3 mb-[20px]">
        {pendingPlans.length === 0 ? (
          <Text type="secondary">No pending tasks</Text>
        ) : (
          pendingPlans.map((item) => (
            <div
              key={item.id}
              className="bg-white !rounded-lg py-2 px-3 flex justify-between sm:flex-row flex-col items-start sm:items-center"
              style={{ border: '1px dashed rgb(229, 231, 235)' }}
            >
              <div className="w-full">
                <Title level={5} style={{ margin: 0, fontSize: 14 }}>
                  {item.task_name}
                </Title>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {item.type}
                </Text>{' '}
                <br></br>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {clientMap[item.client_id]} · {projectMap[item.project_id]}
                </Text>
              </div>

              <div className="flex justify-end w-full pr-[10px] items-center gap-3">
                <Text type="secondary" style={{ fontSize: 12 }}>
                  Planned week : ({dayjs(item.start_date).format('DD MMM')} -{' '}
                  {dayjs(item.end_date).format('DD MMM')})
                </Text>
                <Tooltip title="Postpone">
                  <SendOutlined
                    style={{ color: 'gray' }}
                    onClick={() => {
                      setSelectedPlanId(item.id);
                      setIsDateModalOpen(true);
                    }}
                  />
                </Tooltip>

                <Popconfirm
                  title={
                    <>
                      <div>Please Confirm</div>
                      <div
                        style={{
                          color: 'rgba(0, 0, 0, 0.45)'
                        }}
                      >
                        Are you sure you want to delete this task?
                      </div>
                    </>
                  }
                  placement="left"
                  onConfirm={() =>
                    dispatch(deleteWeeklyPlanAsync({ id: item.id })).then(
                      (res) => {
                        if (res?.payload?.success) {
                          dispatch(
                            fetchWeeklyPlans({
                              status: 'ACTIVE'
                            })
                          );
                        }
                      }
                    )
                  }
                  okText="Delete"
                  cancelText="No"
                >
                  <DeleteOutlined
                    style={{
                      color: 'gray',
                      cursor: 'pointer'
                    }}
                  />
                </Popconfirm>
              </div>
            </div>
          ))
        )}
      </div>

      <AddWeeklyTask
        visible={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setEditTask(null);
        }}
        mode={editTask ? 'edit' : 'add'}
        initialData={editTask}
        initialWeekMonday={selectedWeekMonday}
        executiveMembers={executiveMembers}
      />

      <WeeklyDatePickerModal
        visible={isDateModalOpen}
        planId={selectedPlanId}
        startDate={weekRange[0]?.format('YYYY-MM-DD')}
        endDate={weekRange[1]?.format('YYYY-MM-DD')}
        page={tablePagination.current}
        perPage={tablePagination.pageSize}
        onClose={() => setIsDateModalOpen(false)}
        initialWeekMonday={selectedWeekMonday}
      />

      <style>
        {`
      
 

.ant-form-item-label > label{
color:#595959;
}
.ant-table-pagination.ant-pagination {
padding-right:15px;
}

/* Hide week number column (header + body) */
.ant-picker-week-panel table colgroup col:first-child {
  display: none;
}

.ant-picker-week-panel table thead th:first-child {
  display: none;
}

.ant-picker-week-panel table tbody td:first-child {
  display: none;
}

/* Remove background from Sunday (1st day) and Saturday (7th day) */
.ant-picker-week-panel
  .ant-picker-cell-in-view:nth-child(2),   /* Sunday */
.ant-picker-week-panel
  .ant-picker-cell-in-view:nth-child(8) {  /* Saturday */
  background: transparent !important;
}
  .ant-picker-week-panel
  .ant-picker-cell-in-view:nth-child(n+3):nth-child(-n+7)
  .ant-picker-cell-inner {
  background: #1677ff;
  border-radius: 0;
}
  


        `}
      </style>
    </section>
  );
};

export default WeeklyList;
